/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetPopularCitiesForGeopopupModel, IMappers, TGetPopularCitiesForGeopopupResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IPopularCitiesForGeoPopupResponse } from '../../entities/entities/PopularCitiesForGeoPopupResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetPopularCitiesForGeopopupModel(): TGetPopularCitiesForGeopopupModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'geo-suggest',
    pathApi: '/v1/get-popular-cities-for-geopopup/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IGetPopularCitiesForGeopopupOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchGetPopularCitiesForGeopopup<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IGetPopularCitiesForGeopopupOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetPopularCitiesForGeopopupResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetPopularCitiesForGeopopupModel(),
    config,
  )) as FetchResponse<TGetPopularCitiesForGeopopupResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPopularCitiesForGeoPopupResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetPopularCitiesForGeopopupResponse>;
}
